import { render, staticRenderFns } from "./pet-body-systems-anatomy.vue?vue&type=template&id=c3b1b4f2&scoped=true&"
import script from "./pet-body-systems-anatomy.vue?vue&type=script&lang=js&"
export * from "./pet-body-systems-anatomy.vue?vue&type=script&lang=js&"
import style0 from "./pet-body-systems-anatomy.vue?vue&type=style&index=0&id=c3b1b4f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b1b4f2",
  null
  
)

export default component.exports